import { useDispatch, useSelector } from 'react-redux';
import { savePageFilters } from 'store/Filters/actions/filters';
import { FiltersPageEnum } from 'store/Filters/constants';
import { IRootReducerState } from 'store/store';
import { ViewType } from 'components/ViewTypePicker/ViewTypePicker';
import { SortByOption } from 'pages/NewOrdersFlowPages/types';
import { SortDirection } from 'components/Table/types';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { deleteBuyer, getCompanyBuyers } from 'services/CompanyService';
import { useMutation, useQuery } from 'react-query';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { queryClient } from 'index';

export const useSelectedViewType = () => {
  const dispatch = useDispatch();
  const selectedViewType = useSelector(
    (state: IRootReducerState) =>
      state.filtersInfo?.buyersPage?.selectedViewType
  );

  return {
    selectedViewType,
    setSelectedViewType: (viewType: ViewType) =>
      dispatch(
        savePageFilters({
          page: FiltersPageEnum.BUYERS,
          data: { selectedViewType: viewType },
        })
      ),
  };
};

export const useGetCompanyBuyers = (
  page: number,
  perPage: number,
  searchBy: string,
  sortBy?: SortByOption,
  sortDirection?: SortDirection
) =>
  useQuery({
    queryKey: [
      ReactQueryKeys.GET_COMPANY_BUYERS,
      page,
      perPage,
      searchBy,
      sortBy ?? '',
      sortDirection ?? '',
    ],
    queryFn: () => {
      return getCompanyBuyers(page, perPage, searchBy, sortBy, sortDirection);
    },
  });

export const useDeleteBuyer = () => {
  const { t } = useTranslation();
  return useMutation(
    (buyerId: number) => {
      return deleteBuyer(buyerId);
    },
    {
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
      },
      onSuccess: () => {
        toast.success(t('Buyer is deleted'));
        queryClient.removeQueries(ReactQueryKeys.GET_COMPANY_BUYERS);
      },
      mutationKey: ReactMutationKeys.DELETE_BUYER,
    }
  );
};
